import React from 'react';
import { Modal, Avatar, Row, Col } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faDollarSign, faCog, faSignOutAlt, faHandshake } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { ROUTE_PATH } from "../../constants/routePath";
import { useStore } from "../../hooks/storeContext";
import {
    MoreContent,
    SectionTitle,
    Section,
    AccountCard,
    CustomCard,
    CardContainer,
    MenuButton,
    MenuButtonGroup
} from './styled';

const MoreModal = ({ open, onClose }) => {
    const { authStore } = useStore();

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={600}
            styled={{ backgroundColor: '#f3f3f1' }}
            centered
        >
            <MoreContent>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Section>
                            <AccountCard>
                                <Row align="middle">
                                    <Col xs={8} sm={6} md={4} lg={4} xl={4} xxl={4}>
                                        <Avatar
                                            size={64}
                                            src={authStore.me?.avatar || null}
                                            style={{
                                                background: authStore.me?.avatar ? 'none' : '#000',
                                                fontSize: '32px',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white',
                                            }}
                                        >
                                            {authStore.me?.avatar ? null : authStore.me?.userName?.charAt(0).toUpperCase()}
                                        </Avatar>
                                    </Col>
                                    <Col xs={16} sm={18} md={20} lg={20} xl={20} xxl={20}>
                                        <h4>{authStore.me.userName}</h4>
                                        <p>{authStore.me.email}</p>
                                    </Col>
                                </Row>
                            </AccountCard>
                            <SectionTitle>More Products</SectionTitle>
                            <CardContainer>
                                <Row gutter={[16, 16]}>
                                    <Col xs={8} sm={8} md={8}>
                                        <Link to={ROUTE_PATH.CUSTOMERS}>
                                            <CustomCard>
                                                <FontAwesomeIcon icon={faHeart} style={{ fontSize: '32px' }} />
                                                <h4>Customers</h4>
                                            </CustomCard>
                                        </Link>
                                    </Col>
                                    <Col xs={8} sm={8} md={8}>
                                        <Link to={ROUTE_PATH.PAYMENTS}>
                                            <CustomCard>
                                                <FontAwesomeIcon icon={faDollarSign} style={{ fontSize: '32px' }} />
                                                <h4>Payments</h4>
                                            </CustomCard>
                                        </Link>
                                    </Col>
                                    <Col xs={8} sm={8} md={8}>
                                        <Link to={ROUTE_PATH.REFERRALS}>
                                            <CustomCard>
                                                <FontAwesomeIcon icon={faHandshake} style={{ fontSize: '32px' }} />
                                                <h4>Referrals</h4>
                                            </CustomCard>
                                        </Link>
                                    </Col>
                                </Row>
                            </CardContainer>
                        </Section>
                    </Col>
                    <Col span={24}>
                        <Section>
                            <SectionTitle>Account</SectionTitle>

                            <MenuButtonGroup>
                                <Link to={ROUTE_PATH.PROFILE}>
                                    <MenuButton>
                                        <FontAwesomeIcon icon={faCog} />
                                        <span>Settings</span>
                                    </MenuButton>
                                </Link>
                                <MenuButton onClick={authStore.logout}>
                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                    <span>Logout</span>
                                </MenuButton>
                            </MenuButtonGroup>
                        </Section>
                    </Col>
                </Row>
            </MoreContent>
        </Modal>
    );
};

export default MoreModal;